// @flow

import { connectRouteTo } from 'redux-router-kit';

import { LinkProvider } from '@zapier/common-components';

export default connectRouteTo(LinkProvider);
